import { authRoles } from 'app/auth';
import i18next from 'i18next';

import UnitOptimizerOverviewTable from './table/UnitOptimizerOverviewTable';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'unitOptimizerOverview', en);
i18next.addResourceBundle('hu', 'unitOptimizerOverview', hu);

export default [
	{
		path: '/unit-optimizer-overview/:sessionNameParam?',
		component: UnitOptimizerOverviewTable,
		auth: authRoles.unitOptimizerOverview
	}
];